import { render, staticRenderFns } from "./privateGoods.vue?vue&type=template&id=1647f4d2"
import script from "./privateGoods.vue?vue&type=script&lang=js"
export * from "./privateGoods.vue?vue&type=script&lang=js"
import style0 from "./privateGoods.vue?vue&type=style&index=0&id=1647f4d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports